var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "item" },
    [
      _c(
        "div",
        { staticClass: "item-label" },
        [
          _c(
            "b-form-checkbox",
            {
              ref: "checkedCheckbox",
              class: _vm.checkboxClasses,
              attrs: { checked: _vm.isChecked },
              on: { change: _vm.checkedChanged }
            },
            [
              _vm.nothing
                ? [_vm._v(_vm._s(_vm.nothingAllowedText))]
                : [
                    _c(
                      "span",
                      { staticClass: "item-label-text" },
                      [
                        _c("Label", {
                          attrs: {
                            characteristic: _vm.characteristic,
                            "label-type": _vm.labelType,
                            "highlight-words": _vm.highlightWords
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.hasIcon
                      ? _c("span", { staticClass: "item-label-icon" }, [
                          _c("img", {
                            attrs: {
                              src:
                                _vm.iconPath +
                                "/" +
                                _vm.characteristic.naturalId +
                                ".svg",
                              alt: _vm.label
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.characteristic.description
                      ? _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.html",
                                modifiers: { html: true }
                              }
                            ],
                            staticClass: "item-label-description",
                            attrs: {
                              title:
                                !_vm.descriptionConfig ||
                                !_vm.descriptionConfig.inline
                                  ? _vm.characteristic.description
                                  : undefined
                            }
                          },
                          [
                            _vm.descriptionConfig &&
                            _vm.descriptionConfig.inline
                              ? [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm._f("stripTags")(
                                          _vm.characteristic.description
                                        )
                                      ) +
                                      "\n\t\t\t\t\t"
                                  )
                                ]
                              : _c("Icon", { attrs: { icon: "info" } })
                          ],
                          2
                        )
                      : _vm._e()
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _vm.isChecked &&
          !_vm.nothing &&
          _vm.hasChilds &&
          !_vm.isMaxLevelReached
            ? _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.addParent({
                        characteristic: _vm.characteristic,
                        onClose: _vm.onCloseParent
                      })
                    }
                  }
                },
                [_c("Icon", { attrs: { icon: "pencil" } })],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.searchHits
        ? _c("div", { staticClass: "item-search-hits" }, [
            _vm._v("\n\t\tGefundene Treffer:\n\t\t"),
            _c(
              "ul",
              _vm._l(_vm.searchHits, function(characteristic) {
                return _c(
                  "li",
                  { key: characteristic.id },
                  [
                    _c("Label", {
                      attrs: {
                        characteristic: characteristic,
                        "highlight-words": _vm.highlightWords
                      }
                    })
                  ],
                  1
                )
              }),
              0
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.nothing &&
      _vm.isChecked &&
      _vm.nothingAllowed &&
      !_vm.hasSelectedChildsToLastLevel &&
      _vm.hasChilds &&
      !_vm.isMaxLevelReached
        ? _c("ul", { staticClass: "characteristic-selected-items" }, [
            _c(
              "li",
              [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.addParent({
                          characteristic: _vm.characteristic,
                          onClose: _vm.onCloseParent
                        })
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(_vm.nothingAllowedTextNextLevel) +
                        "\n\t\t\t"
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.supplementAdditions
                  ? _c("Additions", {
                      attrs: {
                        "is-list-styling": false,
                        supplements: _vm.supplementAdditions
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.nothing && _vm.hasSelectedChildsToLastLevel && !_vm.isMaxLevelReached
        ? _c("SelectedChilds", {
            attrs: {
              characteristic: _vm.characteristic,
              selected: _vm.selected,
              styling: _vm.selectedItemsStylingList,
              "label-type": _vm.labelType,
              "show-experience": _vm.selectedItemsConfig
                ? _vm.selectedItemsConfig.showExperience
                : undefined
            },
            on: {
              editItem: function($event) {
                return _vm.addParent({
                  characteristic: _vm.characteristic,
                  onClose: _vm.onCloseParent
                })
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.mustChooseSupplements
        ? _c(
            "div",
            [
              _vm._l(_vm.relevantItemCharacteristicTypes, function(
                itemCharacteristicType
              ) {
                return _c("Supplements", {
                  key: itemCharacteristicType.id,
                  attrs: {
                    "item-characteristic-type": itemCharacteristicType,
                    "initial-selected": _vm.getInitialSupplements(
                      itemCharacteristicType
                    ),
                    "nothing-allowed":
                      _vm.supplementsConfig &&
                      _vm.supplementsConfig.nothingAllowed !== undefined
                        ? _vm.supplementsConfig.nothingAllowed
                        : true,
                    "label-type": _vm.labelType,
                    "with-experience": _vm.withExperience
                  },
                  on: { input: _vm.setSupplements }
                })
              }),
              _vm._v(" "),
              _vm.withExperience
                ? _c(
                    "div",
                    { staticClass: "item-supplements-experience" },
                    [
                      _c("Select", {
                        attrs: {
                          value: _vm.selectedItem.experience,
                          options: _vm.experienceOptions,
                          "empty-value-label":
                            "Welche Erfahrung ist erforderlich?",
                          smaller: ""
                        },
                        on: { change: _vm.experienceChanged }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.nothing
        ? _c(
            "div",
            { staticClass: "item-nothing-choose" },
            [
              _vm.showMultipleHint
                ? [
                    _vm._v("\n\t\t\tOder "),
                    _c("span", { staticClass: "font-weight-extra-bold" }, [
                      _vm._v("Mehrfachauswahl")
                    ]),
                    _vm._v(" möglich:\n\t\t")
                  ]
                : [_vm._v("Oder wähle aus:")]
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.mustChooseAdditions ||
      (_vm.selectedItem && _vm.selectedItem.experience && !_vm.withExperience)
        ? _c("div", { staticClass: "item-additions" }, [
            _vm.selectedItem
              ? _c(
                  "ul",
                  {
                    staticClass: "characteristic-selected-items no-left-padding"
                  },
                  [
                    _c("characteristic-selected-items-item", {
                      attrs: {
                        item: _vm.selectedItem,
                        selected: [],
                        "show-item-label": false,
                        "with-edit-button": _vm.mustChooseAdditions,
                        styling: _vm.selectedItemsStylingList,
                        "label-type": _vm.labelType
                      },
                      on: {
                        edit: function($event) {
                          return _vm.editAdditions(false)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.characteristic.hint && _vm.isChecked
        ? _c("div", {
            staticClass: "item-hint",
            domProps: { innerHTML: _vm._s(_vm.characteristic.hint) }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.confirmDeselect
        ? _c("DeselectPopUp", {
            attrs: { characteristic: _vm.characteristic },
            on: {
              edit: _vm.editAlreadySelected,
              remove: function($event) {
                return _vm.onDeSelectCharacteristic(_vm.characteristic)
              },
              hidden: _vm.dismissDeselectPopUp
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }